import { envConfigProvider } from './config-providers/env-config-provider';
import { localStorageConfigProvider } from './config-providers/local-storage-config-provider';

export const configProviderChain = [localStorageConfigProvider, envConfigProvider];
